import { Accordion, AccordionTab } from 'primereact/accordion'
import { useEffect, useRef, useState } from 'react';
import { DevelopmentTemplate } from '../../../services/Template/development-template';
import { useFormik } from 'formik';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Api } from '../../../services/api';
import { get } from 'react-hook-form';
import "../PM TEMPLATE/PM_TEMPLATE.css";
import { FaCopy } from 'react-icons/fa';
import { Toast } from 'primereact/toast';

const VIEW_DEVELOPMENT_MANAGER_TEMPLATE = ({ projectId, archiveId }) => {

    const [Milestones, setMilestones] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]);
    const [Section9Array, setSection9Array] = useState([{ name: '', }]);
    const [ProjectBudget, setProjectBudget] = useState([1, 2, 3, 4,]);
    const [Section6Array, setSection6Array] = useState([{ name: '', }]);

    useEffect(() => {
        // setIsLoading(false);

        getProjectDetails(archiveId);



        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);

    //! ----------------------------------------------------------
    const getProjectDetails = (id, type) => {

        var url = Api.API_BASE_URL + 'all-template/get-archive-development-manager/' + archiveId + '/' + projectId;

        fetch(url, {
            method: "GET",

        })
            .then((response) => response.json())
            .then((Josn) => {
                if (Josn.error != '') {
                    formik.setFieldValue('dmId', 0);

                } else {

                    formik.setFieldValue('dmId', Josn.dm);

                    formik.setFieldValue('name', Josn.sec_1.name);
                    console.log(Josn.sec_1.name);

                    formik.setFieldValue('expected_date', Josn.sec_2.expected_date);
                    formik.setFieldValue('project_summary', Josn.sec_2.project_summary);
                    formik.setFieldValue('schedule', Josn.sec_2.schedule);
                    formik.setFieldValue('purchase_close_date', Josn.sec_2.purchase_close_date);
                    formik.setFieldValue('notes', Josn.sec_2.notes);
                    formik.setFieldValue('projected_dp_date', Josn.sec_2.projected_dp_date);
                    formik.setFieldValue('address_vp_comment', Josn.sec_2.address_vp_comment);
                    formik.setFieldValue('expected_date_vp_comment', Josn.sec_2.expected_date_vp_comment);
                    formik.setFieldValue('project_summary_vp_comments', Josn.sec_2.project_summary_vp_comments);


                    formik.setFieldValue('schedule_vp_comments', Josn.sec_2.schedule_vp_comments);




                    setMilestones(Josn.sec_3);
                    formik.setFieldValue('section_3', Josn.sec_3);



                    setSection9Array(Josn.sec_4);
                    formik.setFieldValue('section_4', Josn.sec_4);



                    setProjectBudget(Josn.sec_5);
                    formik.setFieldValue('section_5', Josn.sec_5);



                    setSection6Array(Josn.sec_6);
                    formik.setFieldValue('section_6', Josn.sec_6);



                    // getUser();
                }

            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const toast = useRef(null);

    const formik = useFormik({
        initialValues: DevelopmentTemplate.getFormName(),
        validate: (data) => {

        },

    });

    //! -----------------------
    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        fontSize: "18px",
    };

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        // backgroundColor:'yellow',
        // textAlign: 'center',
    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px'

    };

    const borderStyle = {
        // border: "1px solid #E9ECEF",
        // borderLeft: "2px solid #E9ECEF",
    };

    const yesCellStyle = {
        ...cellStyle,
        // background: "#FEC025",
    };



    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    //! ----------------------------------------------------------
    // ----------------------------------------------------------
    const priceBodyTemplatee = (rowData) => {

        if (rowData === '' || rowData === null) {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return <span style={{ color: isNegative ? "red" : "black", textAlign: "center !important", }}>
            {formatCurrency(rowData)}

        </span>
    };
    const formatCurrency = (value) => {


        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    // ----------------------------------------------------------------------------
    const renderTextArea = (fieldName, placeholder, rowCount = 2, formData = '') => (
        <textarea
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            rows={rowCount}
            value={formData != '' ? formData : formik.values[fieldName]}
            disabled={true}
            onChange={(e) => {
                console.log(e.target.value)
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
        ></textarea>
    );

    const renderInputArea = (fieldName, placeholder, type = 'text', formData = '') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formData != '' ? formData : formik.values[fieldName]}
            disabled={true}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value);
                console.log(fieldName);

            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{
                width: '100%',
                height: '40px',
                boxSizing: 'border-box',
                border: 'none',
                fontSize: '16px',
                textAlign: 'center',
                marginTop: '0px',
            }}
        />
    );

    const renderInputAreaForAmount = (fieldName, formData = '') => (
        <InputNumber

            inputId="currency-us"
            //   value={formData != '' ? formData : formik.values[fieldName]}
            className="text-center"
            //   inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            placeholder="$0.00"
            // onValueChange={(e) => formik.setFieldValue(fieldName, e.value)}
            //   onChange={(e) => formik.setFieldValue(fieldName, e.value)}
            mode="currency"
            currency="USD"
            locale="en-US"
            disabled={true}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",
                fontSize: "16px",
                textAlign: "center !important",
                marginTop: "0px",
                outline: 'none',
            }}
        />
    );






    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit} className='pm-template-form' >
                {/* <div className='flex d-flex justify-content-end top-button'>
                    <Button className="m-2 mx-4 p-2 px-3 " severity="Secondary" type="button" title="Copy Client Weekly Update">
                        <strong className="mr-2">Copy weekly update</strong>
                        <FaCopy />
                    </Button>

                    <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center" severity="success" type="submit">
                        <strong className="mr-2">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>

                </div> */}


                <div className="cardd" style={{  border: 'none', }}>

                    <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5]}>
                        <AccordionTab header="Header I" className="mt-2">

                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={2} >
                                                Development Manager Playbook
                                            </th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td style={{ ...cellStyle, width: "300px", }} >
                                                Name:
                                            </td>
                                            <td style={{ ...cellStyle, minWidth: "250px", padding: 0 }} >
                                                {renderTextArea('name', '')}

                                            </td>
                                        </tr>

                                        {/* <tr>
                                            <td style={{ ...cellStyle, }} >
                                                Project Name:
                                            </td>

                                            <td style={{ ...cellStyle, }} >
                                                {renderTextArea('project_name', '')}
                                            </td>
                                        </tr> */}




                                    </tbody>
                                </table>
                            </div>

                            <div className="table-container" style={{ overflowX: "auto", }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>

                                            <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={3} >
                                                ANNUAL DELIVERABLES:
                                            </th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td style={{ ...cellStyle, width: "300px", height: "24px", }} >
                                                1) Identification of new developments
                                            </td>

                                            <td style={{ ...cellStyleW, minWidth: "auto", height: "24px" }} >
                                                To identify new development opportunities that fit into the Lida Group. This also means developing and maintaining relationships with industry professionals
                                            </td>

                                            <td style={{ ...headerStyle, minWidth: "auto", height: "24px" }} >
                                                We Are Team Players
                                            </td>

                                        </tr>

                                        <tr>
                                            <td style={{ ...cellStyle, }} >
                                                2) Analysis of highest and best use
                                            </td>

                                            <td style={{ ...cellStyleW, }} >
                                                To review all new acquisitions for highest and best use. This encompasses determining the wants/needs of the various municipalities in order to not waste time pursuing plans that will not be approved
                                            </td>

                                            <td style={{ ...headerStyle, }} >
                                                We Are Committed to Excellence
                                            </td>

                                        </tr>

                                        <tr>
                                            <td style={{ ...cellStyle, }} >
                                                3) Administration of the development process
                                            </td>

                                            <td style={{ ...cellStyleW, }} >
                                                Organization and follow-up of the various stages of development including liasioning with consultants to push the project forward, submission of required paperwork, attending planning reviews, attending city council meetings, and reciept of building permits
                                            </td>

                                            <td style={{ ...headerStyle, }} >
                                                We Do What We Say We Are Going To Do
                                            </td>

                                        </tr>

                                        <tr>
                                            <td style={{ ...cellStyle, padding: "10px", }} >
                                                4) Schedule and budget
                                            </td>

                                            <td style={{ ...cellStyleW, }} >
                                                Create, monitor and report on project schedule and budget paying particular attention to delays and unbudgeted expenses
                                            </td>

                                            <td style={{ ...headerStyle, }} >

                                            </td>

                                        </tr>



                                    </tbody>
                                </table>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Action Steps" className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, width: "300px" }}>
                                                ACTION STEPS:
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                DEVELOPMENT MANAGER COMMENTS
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                VP LIDA GROUP OF COMPANIES COMMENTS
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {/* <tr>
                                            <td style={borderStyle}>Address:</td>

                                            <td style={cellStyleW}>

                                                {renderTextArea('address', '')}
                                            </td>
                                            <td style={cellStyleW} rowSpan={4} >
                                                {renderTextArea('address_vp_comment', '')}
                                               
                                            </td>

                                        </tr> */}

                                        <tr>
                                            <td style={borderStyle}>Expected Start Date:</td>

                                            <td style={{ ...borderStyle, backgroundColor: 'white' }}>

                                                <input
                                                    type="date"
                                                    name="expected_date"
                                                    id="expected_date"
                                                    // value={formik.values['hereIsYourWeeklySummaryFrom']}
                                                    // onChange={(e) => formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value)}
                                                    style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', textAlign: 'center', }} />
                                            </td>
                                            <td style={cellStyleW} rowSpan={3} >
                                                {renderTextArea('address_vp_comment', '')}

                                            </td>


                                        </tr>

                                        <tr>
                                            <td style={borderStyle}>Project Summary:</td>

                                            <td style={borderStyle}>

                                                <textarea
                                                    placeholder="Five or 6 story purpose built rental project with approximately 63 units"
                                                    style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
                                                ></textarea>
                                            </td>


                                        </tr>





                                        <tr>
                                            <td style={borderStyle}>Schedule:

                                            </td>
                                            <td style={borderStyle}>Purchase close date
                                                <input
                                                    type="date"
                                                    name="purchase_close_date"
                                                    id="purchase_close_date"
                                                    // value={formik.values['hereIsYourWeeklySummaryFrom']}
                                                    // onChange={(e) => formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value)}
                                                    style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', textAlign: 'center', }} />

                                                Projected DP date

                                                <input
                                                    type="date"
                                                    name="projected_dp_date"
                                                    id="projected_dp_date"
                                                    // value={formik.values['hereIsYourWeeklySummaryFrom']}
                                                    // onChange={(e) => formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value)}
                                                    style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', textAlign: 'center', }} />
                                                {/* Notes: */}

                                            </td>

                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="Schedule Milestones" className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "300px" }}>
                                                Schedule Milestones
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Plan Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Current Forecast Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Actual Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Notes:  If applicable, explain why there was a change to the schedule
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                VP LIDA GROUP OF COMPANIES COMMENTSxx
                                            </th>


                                        </tr>
                                    </thead>

                                    <tbody>
                                        {Milestones.map((item, index) => (
                                            <tr >
                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_3.${index}.schedule_milestones`, '', 2, formik.values.section_3[index].schedule_milestones)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_3.${index}.plan_completion_date`, '', 'date', formik.values.section_3[index].plan_completion_date)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_3.${index}.current_forecast_completion_date`, '', 'date', formik.values.section_3[index].current_forecast_completion_date)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_3.${index}.actual_completion_date`, '', 'date', formik.values.section_3[index].actual_completion_date)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_3.${index}.notes`, '', 2, formik.values.section_3[index].notes)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_3.${index}.vp_comments`, '', 2, formik.values.section_3[index].vp_comments)}
                                                </td>



                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="Activities worked on this week" className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, width: "300px" }}>
                                                Activities worked on this week: (Description)
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Contractor
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Brief Scope of Work
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Current Forecasted Completion Date
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                VP LIDA GROUP OF COMPANIES COMMENTS
                                            </th>


                                        </tr>
                                    </thead>
                                    <tbody>

                                        {Section9Array.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW}>{renderTextArea(`section_4.${index}.activities_worked_on_this_week`, '', formik.values.section_4[index].activities_worked_on_this_week)}</td>

                                                <td style={cellStyleW}>{renderTextArea(`section_4.${index}.contractor`, '', '', formik.values.section_4[index].contractor)}</td>

                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_4.${index}.brief_scope_of_work`, '', formik.values.section_4[index].brief_scope_of_work)}
                                                </td>

                                                <td style={cellStyleW}>{renderInputArea(`section_4.${index}.current_f_c_date`, '', 'date', formik.values.section_4[index].current_f_c_date)}</td>

                                                <td style={cellStyleW}>{renderTextArea(`section_4.${index}.vp_comments`, '', formik.values.section_4[index].vp_comments)}</td>



                                            </tr>
                                        ))}


                                    </tbody>


                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="Header V" className="mt-2">
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Project Budget
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Amount
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                VP LIDA GROUP OF COMPANIES COMMENTS
                                            </th>


                                        </tr>
                                    </thead>

                                    <tbody>
                                        {ProjectBudget.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW} >
                                                    {renderTextArea(`section_5.${index}.project_budget`, '', 2, formik.values.section_5[index].project_budget)}

                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputAreaForAmount(`section_5.${index}.amount`, formik.values.section_5[index].amount)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_5.${index}.vp_comments`, '', 2, formik.values.section_5[index].vp_comments)}
                                                </td>



                                            </tr>
                                        ))}


                                    </tbody>


                                </table>
                            </div>

                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Action Items Discussed
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                VP LIDA GROUP OF COMPANIES COMMENTS
                                            </th>



                                        </tr>
                                    </thead>

                                    <tbody>
                                        {Section6Array.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_6.${index}.action_items_discussed`, '', formik.values.section_6[index].action_items_discussed)}
                                                </td>

                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_6.${index}.vp_comments`, '', formik.values.section_5[index].vp_comments)}
                                                </td>




                                            </tr>
                                        ))}

                                    </tbody>


                                </table>
                            </div>
                        </AccordionTab>
                    </Accordion>
                </div>

            </form>
        </>
    )
}

export default VIEW_DEVELOPMENT_MANAGER_TEMPLATE




// ---------------------------------------------------------------------
